import React, { useEffect, useState, useRef } from "react";
import ReportList from "../components/reportList";
import { useNavigate } from "react-router-dom";
import {
  ACCESS_DENIED,
  SW_INSPECTION_ADD,
  SW_INSPECTION_LIST,
  SW_INSPECTION_PROOF_VIEW,
  SW_INSPECTION_VIEW,
  SW_REPORT_HISTORY,
  SW_INSPECTION_PROOF,
  ADMIN_SW_VIEW_PROJECT,
} from "../../../../constant/routeContant";
import * as swInspectionAction from "../../../../redux/storm-water/actions/swInspectionAction";
import * as swCommonAction from "../../../../redux/storm-water/actions/swCommonAction";
import { ToastContainer, toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  API_STATUS,
  HBNEXT_ORG_ID,
  LOGIN_ORG_ID,
  ORG_ID,
  PAGE_SIZE,
  USER_ID,
  SW_CLIENT_MANAGER,
  SW3RD_PARTY_INSPECTOR,
} from "../../../../constant/constant";
import * as clientAction from "../../../../redux/actions/clientAction";
import {
  checkPrivileges,
  hasAllPrivileges,
} from "../../../../utils/rolesHelper";
import { useLocation } from "react-router-dom";
import { getFormatedDate, InactiveClient } from "../../../../utils/helper";
import Loader from "../../../../library/common/Loader";
import { useDebounce } from "../../../../utils/useDebounceSearch";
import { getPreviousRoute } from "../../../../utils/routeTracker";
import * as stateCityAction from "../../../../redux/actions/stateCityAction";

const ReportListContainer = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const stateData = location?.state;
  const isInitialLoad = useRef(true);
  const isInitialStatusMount = useRef(true);
  const isInitialClientsMount = useRef(true);
  const hasRestoredState = useRef(false);
  const stateDataList = useSelector((state) => state.state);
  const preservedState = useRef(
    (() => {
      const shouldPreserve =
        sessionStorage.getItem("swReportListPreserveState") === "true";
      if (!shouldPreserve) return null;
      try {
        const filterObj = JSON.parse(
          sessionStorage.getItem("swReportListFilterObj") || "null",
        );
        const statusIdStr = sessionStorage.getItem("swReportListStatusId");
        return {
          filterObj,
          statusId: statusIdStr ? parseInt(statusIdStr) : null,
        };
      } catch {
        return null;
      }
    })(),
  );

  const [emailReset, setEmailReset] = useState(false);
  const [stodayDate, setStodayDate] = useState(null);
  const [scalculatedDate, setSCalculatedDate] = useState(null);
  const [projects, setProjects] = useState();
  const [clients, setClients] = useState();
  const [selectedReports, setSelectedReports] = useState([]);

  const [search, setSearch] = useState(() => {
    return preservedState.current?.filterObj?.search || "";
  });

  const isProfile = props?.isprofile ?? false;
  const { state } = useLocation();
  const isFromDashboard = state?.from === "dashboard";
  const [clientSearchText, setClientSearchText] = useState("");
  const debouncedClientSearch = useDebounce(clientSearchText, 500);
  const [deletebtncick, setdeletebtncick] = useState(false);
  const getStateData = () => {
    dispatch(stateCityAction.getState());
  };

  const handleUserId = () => {
    if (
      isFromDashboard &&
      checkPrivileges([17]) &&
      checkPrivileges([138]) &&
      !checkPrivileges([136]) &&
      !checkPrivileges([137])
    ) {
      return true;
    }
    return false;
  };
  const isUseridPass = handleUserId();
  const HBView =
    parseInt(ORG_ID()) === parseInt(HBNEXT_ORG_ID) && checkPrivileges([12, 17]);
  const adminView = checkPrivileges([139]);
  const clientView = LOGIN_ORG_ID() !== ORG_ID();
  const [frequencyId, setFrequencyId] = useState("");
  const [myReportsToggle, setMyReportsToggle] = useState(
    isProfile || isUseridPass ? true : false,
  );
  const selectedTab = localStorage.getItem("swReportListTab")
    ? parseInt(localStorage.getItem("swReportListTab"))
    : 5;

  const getInitialStatusId = () => {
    if (preservedState.current?.statusId) {
      return preservedState.current.statusId;
    }
    // For SW_CLIENT_MANAGER or SW3RD_PARTY_INSPECTOR, always default to Completed (6)
    if (
      hasAllPrivileges(SW_CLIENT_MANAGER) ||
      hasAllPrivileges(SW3RD_PARTY_INSPECTOR)
    ) {
      return 6;
    }
    return isProfile ? 6 : (selectedTab ?? 6);
  };

  const [statusId, setStatusId] = useState(getInitialStatusId());
  const [checktab, setchecktab] = useState(getInitialStatusId());
  const [statusIdsvalue, setStatusIdsvalue] = useState(isProfile ? 5 : 5);

  useEffect(() => {
    if (isFromDashboard) {
      localStorage.setItem("swReportListTab", `7`);
      setchecktab(7);
      setStatusId(7);
      setProjects("");
      setClients("");
      setFrequencyId("");
    }
  }, [isFromDashboard]);
  const statusHander = (status) => {
    setStatusId(status);
    setStatusIdsvalue(
      parseInt(status) === 6
        ? 5
        : parseInt(status) === 5
          ? 10
          : parseInt(status),
    );
    localStorage.setItem("swReportListTab", `${status}`);
    // setProjects();
    // setClients();
    setFrequencyId("");
  };
  const refData = {
    flags: [3, 4],
  };
  const getSwReference = useSelector((state) => state.getSwReference);
  const getSwReferenceData = (data) => {
    dispatch(swCommonAction.getSwReference(data));
  };
  useEffect(() => {
    // if (isInitialStatusMount.current) {
    //   isInitialStatusMount.current = false;
    //   return;
    // }
    if (statusId === 7) {
      const days = parseInt(90);
      const today = new Date();
      const calculated = new Date(today);
      calculated.setDate(today.getDate() + (days - 1));
      setSCalculatedDate(calculated);
      setStodayDate(today);
      setchecktab(7);
    } else if (statusId === 6 || statusId === 8 || statusId === 5) {
      // !  statusId === 8 yaha kya hoga
      setSCalculatedDate(null);
      setStodayDate(null);
      setchecktab(statusId);
    }
  }, [statusId]);

  const defaultData = {
    search: search ? search : "",
    inspectionTypeId: 0,
    projectId: 0,
    customerId: parseInt(ORG_ID()),
    statusId: statusId,
    startDate: statusId === 7 && stodayDate ? getFormatedDate(stodayDate) : "",
    endDate:
      statusId === 7 && scalculatedDate ? getFormatedDate(scalculatedDate) : "",
    page: 1,
    pageSize: PAGE_SIZE,
    userId:
      isProfile || isUseridPass || myReportsToggle ? parseInt(USER_ID()) : "",
    isDailyReport: false,
    statusIds: statusIdsvalue,
  };
  const getSwInspectionList = useSelector((state) => state.getSwInspectionList);
  const getSwInspectionListData = (data) => {
    dispatch(swInspectionAction.getSwInspectionList(data));
    dispatch(swInspectionAction.getSwInspectionFilterObj(data));
  };
  const getBulkInspectionDetails = useSelector(
    (state) => state.getBulkInspectionDetails,
  );
  const getBulkInspectionDetailsData = (data, client) => {
    dispatch(
      swInspectionAction.getBulkInspectionDetails({
        orgId: clients?.key ? clients?.key : ORG_ID(),
        userId: USER_ID(),
        inspectionIds: data,
      }),
    );
  };
  const getBulkInspectionFiles = useSelector(
    (state) => state.getBulkInspectionFiles,
  );
  const getBulkInspectionFilesData = (data) => {
    dispatch(swInspectionAction.getBulkInspectionFiles(data));
  };
  const swOpenItemDetail = useSelector((state) => state.swOpenItemDetail);
  const getOpenItemDetailData = (data) => {
    dispatch(swInspectionAction.createSwOpenItemDetail(data));
  };

  useEffect(() => {
    if (
      !getBulkInspectionDetails?.isLoading &&
      getBulkInspectionDetails?.status === "SUCCESS" &&
      selectedReports?.length > 0
    ) {
      statusHander(8);
      localStorage.setItem("swReportListTab", `8`);
      setSelectedReports([]);
    }
  }, [getBulkInspectionDetails]);

  const deleteReport = useSelector((state) => state.deleteSwInspection);

  const allClients = useSelector((state) => state.searchAllClientsReducerData);
  const isSearchClientLoading = allClients.isLoading;

  const searchClient = (event) => {
    setClientSearchText(event.target.value);
  };

  useEffect(() => {
    dispatch(clientAction.searchAllClients(debouncedClientSearch));
  }, [debouncedClientSearch]);

  const getProjectContactsEmailDetails = useSelector(
    (state) => state.getProjectContactsEmailDetails,
  );

  const isLoading = useSelector(
    (state) =>
      state.getSwInspectionList?.isLoading ||
      state.deleteSwInspection?.isLoading ||
      state.getProjectContactsEmailDetails.isLoading,
  );

  useEffect(() => {
    getSwReferenceData(refData);
    getStateData();
  }, []);

  const handleEditOnClick = (row) => {
    if (InactiveClient()) return;
    const currentFilterObj = getSwInspectionList?.filterObj || {};
    sessionStorage.setItem("swReportListPreserveState", "true");
    sessionStorage.setItem("swReportListStatusId", statusId.toString());
    sessionStorage.setItem(
      "swReportListFilterObj",
      JSON.stringify({
        ...currentFilterObj,
        search: search,
        statusId: statusId,
      }),
    );
    navigate(SW_INSPECTION_ADD, {
      state: {
        row: row,
        editMode: true,
      },
    });
  };
  const reportHistoryOnClick = (row) => {
    const currentFilterObj = getSwInspectionList?.filterObj || {};
    sessionStorage.setItem("swReportListPreserveState", "true");
    sessionStorage.setItem("swReportListStatusId", statusId.toString());
    sessionStorage.setItem(
      "swReportListFilterObj",
      JSON.stringify({
        ...currentFilterObj,
        search: search,
        statusId: statusId,
      }),
    );
    navigate(SW_REPORT_HISTORY, {
      state: {
        row: row,
      },
    });
  };
  const viewProjectOnClick = (row) => {
    const currentFilterObj = getSwInspectionList?.filterObj || {};
    sessionStorage.setItem("swReportListPreserveState", "true");
    sessionStorage.setItem("swReportListStatusId", statusId.toString());
    sessionStorage.setItem(
      "swReportListFilterObj",
      JSON.stringify({
        ...currentFilterObj,
        search: search,
        statusId: statusId,
      }),
    );
    // navigate(SW_REPORT_HISTORY, {
    //   state: {
    //     row: row,
    //   },
    // });
    navigate(ADMIN_SW_VIEW_PROJECT, {
      state: {
        projectid: row?.projectId,
        customerId: row?.customerId,
        customerName: row?.customer,
        editMode: true,
        stateId: row?.stateId,
        clients: row?.customerId,
        projectNumber: row?.projectNumber,
        projectName: row?.name,
      },
    });
  };
  const viewOnClick = (row) => {
    const currentFilterObj = getSwInspectionList?.filterObj || {};
    sessionStorage.setItem("swReportListPreserveState", "true");
    sessionStorage.setItem("swReportListStatusId", statusId.toString());
    sessionStorage.setItem(
      "swReportListFilterObj",
      JSON.stringify({
        ...currentFilterObj,
        search: search,
        statusId: statusId,
      }),
    );
    if (row?.isExternal) {
      navigate(SW_INSPECTION_PROOF_VIEW, {
        state: {
          inspectionDetails: row,
        },
      });
    } else {
      navigate(SW_INSPECTION_VIEW, {
        state: {
          inspectionId: row?.reportId,
          customerId: row?.customerId,
        },
      });
    }
  };

  const handleAddOnClick = (row) => {
    if (InactiveClient()) return;
    navigate(SW_INSPECTION_ADD, {
      state: {
        row: row,
        addMode: true,
        addDirectInspection: false,
      },
    });
  };

  const onRowClick = (row) => {
    if (row?.value) {
      navigate(SW_INSPECTION_VIEW, {
        state: {
          inspectionId: row?.id,
          customerId: row?.customerId,
        },
      });
    }
  };

  const handleDeleteOnClick = (data) => {
    setdeletebtncick(true);
    dispatch(swInspectionAction.deleteSwInspection(data));
  };

  const getProjectContactsEmailDetailsData = (data) => {
    dispatch(swInspectionAction.getProjectContactsEmailDetails(data));
  };

  const sendEmailOnClick = (row) => {
    if (InactiveClient()) return;
    if (!row?.isClientActive) {
      toast("This Client is Inactive");
      return;
    }
    const currentFilterObj = getSwInspectionList?.filterObj || {};
    sessionStorage.setItem("swReportListPreserveState", "true");
    sessionStorage.setItem("swReportListStatusId", statusId.toString());
    sessionStorage.setItem(
      "swReportListFilterObj",
      JSON.stringify({
        ...currentFilterObj,
        search: search,
        statusId: statusId,
      }),
    );
    setEmailReset(true);
    const data = {
      orgId: row?.customerId,
      inspectionId: row?.reportId,
      fromDate: "",
      toDate: "",
      projectIds: [0],
    };
    getProjectContactsEmailDetailsData(data);
  };

  useEffect(() => {
    if (
      deleteReport?.status === API_STATUS.SUCCESS &&
      (deleteReport?.[0]?.responseCode === "HBNG001" ||
        deleteReport?.[0]?.responseCode !== "HBNG015")
    ) {
      if (getSwInspectionList?.filterObj) {
        getSwInspectionListData(getSwInspectionList.filterObj);
      } else {
        getSwInspectionListData(defaultData);
      }
    }
  }, [deleteReport]);
  useEffect(() => {
    if (
      deleteReport?.[0]?.responseCode === "HBNG015" &&
      deletebtncick &&
      deleteReport?.status === API_STATUS.SUCCESS
    ) {
      toast(deleteReport.responseMessage || "This Client is Inactive");

      return () => {
        setdeletebtncick(false);
        dispatch(swInspectionAction.clearSwInspectionDelete());
      };
    }
  }, [deleteReport]);
  useEffect(() => {
    if (!isInitialLoad.current) {
      if (hasRestoredState.current) {
        return;
      }
      if (
        !stateData &&
        checktab !== 8 &&
        !isFromDashboard &&
        checktab &&
        statusId
      ) {
        if (!isFromDashboard && stodayDate && scalculatedDate) {
          getSwInspectionListData({ ...defaultData, statusId: statusId });
        } else if (checktab !== 7) {
          getSwInspectionListData({
            ...defaultData,
            statusId: statusId,
            startDate: "",
            endDate: "",
          });
        }
      } else if (checktab === 8) {
        getBulkInspectionFilesData({
          page: 1,
          pageSize: 10,
          userId: parseInt(USER_ID()),
        });
      } else if (isFromDashboard) {
        getSwInspectionListData({
          ...defaultData,
          userId:
            isProfile || isUseridPass || myReportsToggle
              ? parseInt(USER_ID())
              : "",
        });
      }
      return;
    }

    isInitialLoad.current = false;

    const savedFilterObj = preservedState.current?.filterObj;

    if (savedFilterObj) {
      hasRestoredState.current = true;
      getSwInspectionListData(savedFilterObj);
      sessionStorage.removeItem("swReportListPreserveState");
      sessionStorage.removeItem("swReportListStatusId");
      sessionStorage.removeItem("swReportListFilterObj");
      return;
    }

    if (
      !stateData &&
      checktab !== 8 &&
      !isFromDashboard &&
      checktab &&
      statusId
    ) {
      if (!isFromDashboard && stodayDate && scalculatedDate) {
        getSwInspectionListData({ ...defaultData, statusId: statusId });
      } else if (checktab !== 7) {
        getSwInspectionListData({
          ...defaultData,
          statusId: statusId,
          startDate: "",
          endDate: "",
        });
      }
    } else if (checktab === 8) {
      getBulkInspectionFilesData({
        page: 1,
        pageSize: 10,
        userId: parseInt(USER_ID()),
      });
    } else if (isFromDashboard) {
      getSwInspectionListData({
        ...defaultData,
        userId: isUseridPass ? parseInt(USER_ID()) : "",
      });
    }
  }, [checktab, stateData, stodayDate, scalculatedDate, isFromDashboard]);
  useEffect(() => {
    if (isInitialClientsMount.current) {
      isInitialClientsMount.current = false;
      return;
    }
    if (hasRestoredState.current) {
      return;
    }
    if (clients) {
      const defaultClientData = {
        search: search ? search : "",
        inspectionTypeId: 0,
        projectId: projects?.key ? projects?.key : 0,
        customerId: clients?.key ? clients?.key : parseInt(ORG_ID()),
        statusId: statusId,
        startDate:
          statusId === 7 && stodayDate ? getFormatedDate(stodayDate) : "",
        endDate:
          statusId === 7 && scalculatedDate
            ? getFormatedDate(scalculatedDate)
            : "",
        page: 1,
        pageSize: PAGE_SIZE,
        userId:
          isProfile || isUseridPass || myReportsToggle
            ? parseInt(USER_ID())
            : "",
        clientObj: clients,
        statusIds: statusIdsvalue,
      };
      getSwInspectionListData(defaultClientData);
    }
  }, [clients]);

  useEffect(() => {
    if (hasRestoredState.current) {
      const timer = setTimeout(() => {
        hasRestoredState.current = false;
      }, 100);
      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    if (
      getProjectContactsEmailDetails?.status === "SUCCESS" &&
      getProjectContactsEmailDetails?.isLoading === false &&
      emailReset
    ) {
      toast("Mail Send successfully");
    }
  }, [getProjectContactsEmailDetails, emailReset]);

  return (
    <>
      {checkPrivileges([12, 102, 103, 104]) ? (
        <>
          {getBulkInspectionDetails.isLoading && <Loader />}
          <ReportList
            isLoading={isLoading}
            swInspectionList={
              isLoading ? [] : getSwInspectionList?.data?.inspectionReports
            }
            count={getSwInspectionList?.data?.recordsCount}
            getSwInspectionListData={getSwInspectionListData}
            handleEditOnClick={handleEditOnClick}
            viewOnClick={viewOnClick}
            inspectionTypeValue={getSwReference?.data}
            allClients={allClients?.data}
            isSearchClientLoading={isSearchClientLoading}
            searchClient={searchClient}
            handleDeleteOnClick={handleDeleteOnClick}
            onRowClick={onRowClick}
            statusHander={statusHander}
            statusId={statusId}
            stateData={stateData}
            scalculatedDate={scalculatedDate}
            stodayDate={stodayDate}
            setProjects={setProjects}
            projects={projects}
            setClients={setClients}
            clients={clients}
            selectedReports={selectedReports}
            setSelectedReports={setSelectedReports}
            getBulkInspectionDetailsData={getBulkInspectionDetailsData}
            getBulkInspectionFiles={getBulkInspectionFiles}
            getBulkInspectionFilesData={getBulkInspectionFilesData}
            getProjectContactsEmailDetailsData={
              getProjectContactsEmailDetailsData
            }
            handleAddOnClick={handleAddOnClick}
            frequencyId={frequencyId}
            setFrequencyId={setFrequencyId}
            isProfile={isProfile}
            getOpenItemDetailData={getOpenItemDetailData}
            swOpenItemDetail={swOpenItemDetail}
            isFromDashboard={isFromDashboard}
            isUseridPass={isUseridPass}
            setEmailReset={setEmailReset}
            reportHistoryOnClick={reportHistoryOnClick}
            search={search}
            setSearch={setSearch}
            swInspectionListData={getSwInspectionList}
            setdeletebtncick={setdeletebtncick}
            deletebtncick={deletebtncick}
            statusIdsvalue={statusIdsvalue}
            sendEmailOnClick={sendEmailOnClick}
            viewProjectOnClick={viewProjectOnClick}
            myReportsToggle={myReportsToggle}
            onMyReportsToggle={setMyReportsToggle}
            state={stateDataList && stateDataList.data?.getState}
          />
          <ToastContainer />
        </>
      ) : (
        navigate(ACCESS_DENIED)
      )}{" "}
    </>
  );
};

export default ReportListContainer;
